<style scoped>
div {
  text-align: center;
}
.body-area {
  width: 100%;
  max-width: 750px;
  height: 100svh; /* 使用视口高度 */
  background: #000;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
}
.txt {
  font-weight: 400;
  color: #1d1d1f;
}
.game-bg {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.progress-container {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  width: 80%;
  max-width: 600px;
  z-index: 10;
}
.progress-wrapper {
  position: relative;
}
.progress-text {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  color: #692b26;
  font-size: 12px;
  font-weight: 600;
}
.loading-text {
  color: #411e09;
  font-size: 14px;
  margin-bottom: 5px;
  text-align: center;
  font-weight: 500;
}

.info-text {
  color: #411e09;
  font-size: 11px;
  line-height: 11px;
  text-align: center;
  margin-top: 1px;
}

.info-blank {
  margin-top: 10px;
}
</style>

<template>
  <div class="body-area">
    <img class="game-bg" src="../assets/game-bg.png" alt="" />
    <div class="progress-container">
      <div class="loading-text">{{ loadingText }}</div>
      <div class="progress-wrapper">
        <el-progress
          :percentage="progressPercentage"
          :show-text="false"
          :stroke-width="18"
        />
        <span class="progress-text">{{ Math.floor(progressPercentage) }}%</span>
      </div>
      <div class="info-text info-blank">
        著作权人：上海景云供应链管理有限公司
      </div>
      <div class="info-text">批准文号：新广出审[2024]100x9号</div>
      <div class="info-text">出版物号：ISBN 978-7-xxx1-0xx9-1</div>
      <div class="info-text">
        抵制不良游戏 拒绝盗版游戏 注意自我保护 谨防受骗上当
      </div>
      <div class="info-text">
        适度游戏益脑 沉迷游戏伤身 合理安排时间 享受健康生活
      </div>
    </div>
  </div>
</template>

<script>
import app from "@/App.vue";
var $this = {};
export default {
  data() {
    return {
      progressPercentage: 0,
      progressInterval: null,
      loadingText: "正在初始化...",
    };
  },
  mounted: function () {
    this.screenWidth = window.innerWidth;
    this.setSize();
    window.onresize = () => {
      this.screenWidth = window.innerWidth;
      this.setSize();
    };

    this.startProgress();
  },
  beforeDestroy() {
    // 清除定时器
    if (this.progressInterval) {
      clearInterval(this.progressInterval);
    }
  },
  beforeCreate() {
    $this = this;
  },
  methods: {
    setSize: function () {
      // 设置根元素字体大小，用于rem适配
      const html = document.documentElement;
      const width = html.clientWidth;
      const fontSize = (width / 750) * 100;
      html.style.fontSize = fontSize + "px";
    },
    startProgress() {
      // 第一阶段：加载到20%
      this.progressPercentage = 20;
      this.loadingText = "正在加载基础资源...";

      // 第二阶段：1.5秒后加载到40%
      setTimeout(() => {
        this.progressPercentage = 40;
        this.loadingText = "正在加载游戏数据...";

        // 第三阶段：再过1秒加载到80%
        setTimeout(() => {
          this.progressPercentage = 80;
          this.loadingText = "正在加载游戏场景...";

          // 第四阶段：再过2.5秒加载到100%
          setTimeout(() => {
            this.progressPercentage = 100;
            this.loadingText = "正在连接游戏服务器...";
          }, 2500);
        }, 1000);
      }, 1500);
    },
  },
};
</script>
